import { Component } from '@angular/core';
import { RankData, PlayerInfo } from './store-item';
import { RankingService } from './services/ranking.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {

  public curServer: string = "origem";
  public startSegment: string = "celestial";
  public loading: boolean = true;

  public celestialRank: PlayerInfo[];
  public guildsRank: PlayerInfo[];
  public rankData: RankData;

  constructor(private rankingService: RankingService) { }

  ngOnInit() {
  }

  ngAfterContentInit() {
    this.getRanking();
  }

  private refactoringJson(rankData : RankData) : void {
    // console.log(rankData);
    this.loading = false;
    this.rankData = rankData;
    this.celestialRank = rankData.celestial;
    this.guildsRank = rankData.guildas;

    var index = 1;
    for (let item of this.celestialRank) {
      item.index = index;
      index++;
    }

    index = 1;
    for (let item of this.guildsRank) {
      item.index = index;
      index++;
    }
  }

  getRanking(): void {
    this.loading = true;
    this.rankingService.getRanking(this.curServer).subscribe(rankData => this.refactoringJson(rankData) );
  }

  public doSegmentAction($event): void {
    switch ($event.value) {
      case "celestial":
      this.startSegment = "celestial";
        break;
      case "guilds":
      this.startSegment = "guilds";
        break;
    }
  }

  public changeServerAction($event): void {
    this.startSegment = "celestial";
    this.curServer = $event.value;
    this.getRanking();
  }
}
